<template>
    <base-form :formType="'contactUs'">
        <template v-slot:slotData="res">
            <van-field v-model="res.formData.consult" name="consult" label="我要咨询" placeholder="请输入咨询内容"
                :rules="[{ required: true, message: '请输入我要咨询内容' }]">
                <template #label>
                    我要咨询<span class="required-star">*</span>
                </template>
            </van-field>
            <van-field rows="4" type="textarea" show-word-limit maxlength="200" autosize v-model="res.formData.remark"
                name="remark" label="备注信息" placeholder="请输入备注信息" :rules="[{ required: true, message: '请输入我要备注信息' }]">
                <template #label>
                    备注信息<span class="required-star">*</span>
                </template>
            </van-field>
        </template>
    </base-form>
</template>
  
<script>
import BaseForm from "./BaseForm.vue";

export default {
    components: { BaseForm },
    data() {
        return {

        }
    },
    mounted(){
        this.initShare();
        this.$dataStatistics({
            page_title: `联系我们`,
        },'访问');
    },
};
</script>
<style lang="less" scoped>
::v-deep .van-field__word-limit {
    font-size: 14px !important;
    color: #9F9F9F !important;;
}
</style>
